
export class CreateUserTicketBulkRequestDto {
  ticketId: string;
  userId: string;
  orderId: string;
  quantity: number;
}
